export default {
    key: 'guided-tour',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: true,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: undefined,
    categoryId: '204390dd-6eba-4368-87db-1a436c466a67',
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    contentfulId: 'guided-tour',
    steps: [],

} satisfies ProductConfigActivity;
